<template>
  <Admin style="background: #f2f2f2">
    <v-main>
      <v-container fluid>
        <v-card class="rounded-xl tw-min-h-80">
          <v-card-text v-if="!selectedCompany.isDemo" class="tw-p-0">
            <v-breadcrumbs :items="items" class="tw-pt-10 tw-pl-10">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true"
                >
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
            <v-row class="row-wrapper tw-px-10" v-if="!loading">
              <v-col class="tw-block">
                <h2
                  class="tw-font-bold tw-text-xl tw-text-black tw-tracking-wide tw-inline-block"
                >
                  จัดการใบสั่งขายออนไลน์
                </h2>
                <div
                  class="tw-inline-block"
                  v-if="shopList && shopList.length > 0"
                >
                  <!-- shop avatar -->
                  <v-avatar
                    class="tw-inline-block tw-ml-3 tw-align-top"
                    color="primary"
                    rounded
                    size="44"
                  >
                    <img
                      v-if="shopLogoUrl"
                      :srcset="
                        shopLogoUrl +
                        '=c-w320, ' +
                        shopLogoUrl +
                        '=c-w480 1.5x, ' +
                        shopLogoUrl +
                        '=c-w640 2x'
                      "
                      :src="shopLogoUrl + '=c-w640'"
                    />
                  </v-avatar>
                  <!-- shop dropdown -->
                  <v-select
                    class="tw-inline-block tw-ml-3"
                    dense
                    height="44px"
                    style="width: 200px"
                    outlined
                    :items="shopListOptions"
                    v-model="shopId"
                    @change="onSelectShop"
                  ></v-select>
                </div>
              </v-col>
              <!-- right buttons -->
              <v-col v-if="shopList.length > 0" class="tw-flex-grow-0">
                <div class="tw-flex">
                  <v-btn
                    color="primary"
                    outlined
                    class="tw-mr-2"
                    :to="{ name: 'Company.Settings.Shops.Add' }"
                  >
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    เพิ่มร้านค้า
                  </v-btn>
                  <v-btn
                    color="primary"
                    outlined
                    v-if="shopId"
                    :to="{
                      name: 'Company.Settings.Shops.Edit',
                      params: { shopId: this.shopId },
                    }"
                  >
                    <v-icon left>mdi-square-edit-outline</v-icon>
                    แก้ไขร้านค้า
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <template v-if="!loading">
              <!-- shop connected  -->
              <shop-list
                v-if="shopList && shopList.length > 0"
                :companyId="companyId"
                :shopId="shopId"
              />
              <!-- no shop connected-->
              <shop-empty :companyId="companyId" v-else />
            </template>
          </v-card-text>
          <div
            v-else
            class="align-center justify-center"
            style="height: 200px; display: flex"
          >
            No Permission
          </div>
        </v-card>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Admin from '../../../components/admin/admin-main-template.vue'
import ShopEmpty from '../../../components/admin/settings/shops/shop-empty.vue';
import ShopList from '../../../components/admin/settings/shops/shop-list.vue';

export default {
  name: 'Shop',
  components: {
    Admin,
    ShopEmpty,
    ShopList,
  },
  computed: {
    ...mapGetters({
      shopListOptions: 'shops/listOptions',
    }),
    ...mapState({
      selectedCompany: state => state.companies.selectedCompany,
      loading: state => state.shops.loading,
      shopList: state => state.shops.list,
    }),
    shopLogoUrl() {
      return this.shopList.find(o => o.id == this.shopId)?.logoImageUrl
    }
  },
  data: () => ({
    items: [
      {
        text: 'ตั้งค่า',
        disabled: false,
        to: { name: 'Company.Settings' },
      },
      {
        text: 'จัดการใบสั่งขายออนไลน์',
        disabled: true,
      },
    ],
    shopId: '',
    companyId: '',
  }),
  watch: {
    '$route.params.shopId': function (shopId) {
      this.shopId = shopId
      if (this.shopList.length === 0) {
        this.getData()
      }
    }
  },
  async created() {
    const companyId = this.$route.params.companyId
    const shopId = this.$route.params.shopId
    this.companyId = companyId
    await this.getData()
    if (shopId) {
      this.shopId = shopId
    }
    // select first shop by default
    if (!shopId && this.shopListOptions.length > 0) {
      this.shopId = this.shopListOptions[0].value
    }
  },
  methods: {
    async getData() {
      await this.$store.dispatch('shops/getList', { companyId: this.companyId })
    },
    onSelectShop() {
      this.$router.push({ params: { ...this.$route.params, shopId: this.shopId } })
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
